import React, { Dispatch, SetStateAction } from 'react'

import { B2, XStack, colors } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { i18n } from '@zet/localization'

import { WorldOutlined } from '../../assets/svgs'
import { addedFromAgentWebsiteFilter } from '../utils/constants'

const AddedFromAgentWebsiteFilter = ({
  filter,
  setFilter,
  setSelectedStatus,
  setSelectedSource,
}: {
  filter: string
  setFilter: Dispatch<SetStateAction<string>>
  setSelectedStatus: Dispatch<SetStateAction<number[]>>
  setSelectedSource: Dispatch<SetStateAction<string[]>>
}) => {
  function handleFilter() {
    setFilter(addedFromAgentWebsiteFilter.name)
    setSelectedStatus(addedFromAgentWebsiteFilter.value)
    setSelectedSource(addedFromAgentWebsiteFilter.customerSource)
  }
  return (
    <Pressable
      onPress={handleFilter}
      className={`mr-3 flex-row items-center rounded-md ${
        filter === addedFromAgentWebsiteFilter.name
          ? 'bg-primary-150'
          : 'border-grays-40 border'
      } px-2 py-[6]`}
      eventName="click_action"
      eventPayload={{
        item_name: 'add_customer_non_verified_filter',
        filter_name: addedFromAgentWebsiteFilter.name,
      }}
    >
      <XStack className="items-center">
        <WorldOutlined
          width={20}
          color={`${
            filter === addedFromAgentWebsiteFilter.name
              ? colors.grays[30]
              : colors.grays[80]
          }`}
        />
        <B2
          className={`ml-2 ${
            filter === addedFromAgentWebsiteFilter.name
              ? 'text-grays-30'
              : 'text-grays-80'
          }`}
        >
          {i18n.t(addedFromAgentWebsiteFilter.label)}
        </B2>
      </XStack>
    </Pressable>
  )
}

export default AddedFromAgentWebsiteFilter
